module.exports = __webpack_public_path__ + "assets/home-min.4b019e41f9aeda94ce2605e1b50deebc.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/CanGuidic/home-min.jpg
 ** module id = 415
 ** module chunks = 0
 **/